import { render } from "./notification-details.vue?vue&type=template&id=768b355d&ts=true"
import script from "./notification-details.vue?vue&type=script&lang=ts"
export * from "./notification-details.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__